import type { CSSProperties, ReactNode } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

export interface ListWrapperProps {
  children: ReactNode;
  className?: string;
  isFullPage?: boolean;
  style?: CSSProperties;
}

export const ListWrapper = ({
  children,
  className,
  style,
  isFullPage = false,
}: ListWrapperProps) => (
  // h-[calc(100%-92px)] is the height of the list minus the height of the header, tabs and margin.
  <div
    className={classNames(
      "flex w-full flex-col justify-between space-y-px overflow-y-auto [scrollbar-gutter:stable]",
      {
        "h-[calc(100dvh-95px)] p-2 lg:h-[calc(100%-92px)]": !isFullPage,
      },
      className,
    )}
    style={style}
    id={
      isFullPage
        ? "user-notifications-full-page-header"
        : "user-notifications-panel-header"
    }
  >
    {children}
  </div>
);
